export default "__VITE_ASSET__B$vWqjaP__"